import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormGroupDirective, FormArray, NgForm, Validators, } from '@angular/forms';
import * as moment from 'moment';
import * as _ from 'lodash';
import { frequencyDays } from '../../_models/staticArray'
import { Router } from '@angular/router';

@Component({
  selector: 'app-training-job-dates',
  templateUrl: './training-job-dates.component.html',
  styleUrls: ['./training-job-dates.component.scss']
})
export class TrainingJobDatesComponent implements OnInit {

  public frequencyDays = [
    { id: '0', day: 'Sunday', checked: false },
    { id: '1', day: 'Monday', checked: false },
    { id: '2', day: 'Tuesday', checked: false },
    { id: '3', day: 'Wednesday', checked: false },
    { id: '4', day: 'Thursday', checked: false },
    { id: '5', day: 'Friday', checked: false },
    { id: '6', day: 'Saturday', checked: false }
];
@Input('frequency') frequency: any;
@Input('duration') duration: any;
@Input('startingDate') startingDate: any;
@Input('singleJobDate') singleJobDate: any; // for edit event
@Input('datesOnCourseChange') datesOnCourseChange: any; // generate new dates on course change
@Output() dateChange: EventEmitter<any> = new EventEmitter<any>();
@Input('loginUser') userLogin
@Input('jobReset') resetJob

dateForm;
courseDates = [];
temp = moment(this.startingDate)
tempArray = [];
finalCourseDates;
dayOfTheWeek;
day;
event;
totalDays = [];
dayExist: Boolean;
checkEnable: Boolean = true;
user;
constructor(public formBuilder: FormBuilder, public router: Router) {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    // if (this.user && this.user.isClient){
    //   this.checkEnable = true
    // } else{
    //   this.checkEnable = false;
    // }
}

ngOnInit() {
    console.log("IN JOBDATE", "DAY OF THE WEEK", this.dayOfTheWeek, this.frequency, "DURATION IS ==", this.duration, "STARTING DATE IS: ", this.startingDate, this.singleJobDate)
    if (this.router.url.includes('/add-job')) {
        this.temp = moment(this.startingDate)

        this.dateForm = this.formBuilder.group({
            frequency: new FormArray([], Validators.required),
            // singleJobDates : new FormControl()
        })
        this.addCheckboxes();

        if (this.frequency != undefined) {
            console.log("this.frequency in edit!!!!!!!!!!", this.frequency);
            this.checkEnable = false;
            this.frequency.forEach((item => {
                this.frequencyDays.forEach((arrayItem) => {
                    if (arrayItem.day == item) {
                        arrayItem.checked = true
                    }
                })
            }))
            this.singleJobDate.forEach((date) => {
                // let temp = new Date(date.date)
                this.courseDates.push(date)
            })
            console.log("this is the course dates", this.courseDates);

            this.finalCourseDates = this.courseDates.sort((a, b) => b - a).reverse();
        }
    }
}


addCheckboxes() {
    this.frequencyDays.forEach(() => {
        const control = new FormControl();
        (this.dateForm.controls.frequency as FormArray).push(control);
    });
}

enableCheckBoxes() {
    this.checkEnable = false
}

ngOnChanges(changes: SimpleChanges): void {
    console.log("in changes in job dates", changes)
    if (changes.datesOnCourseChange && changes.datesOnCourseChange.currentValue) {
        this.onCourseChange()
    }
    if (changes.duration && changes.duration.currentValue) {
        this.enableCheckBoxes()
    }
    if (changes.resetJob && changes.resetJob.currentValue) {
        this.finalCourseDates = []
        // this.addCheckboxes()
        this.clearCheckBoxes()
    }

    if (changes.frequency && changes.frequency.currentValue) {
        this.frequency = []
        this.frequency = changes.frequency.currentValue
        this.totalDays = changes.frequency.currentValue
        this.checkEnable = false;
        console.log("this is the total days of job", this.frequency);

        this.frequency.forEach((item => {
            this.frequencyDays.forEach((arrayItem) => {
                if (arrayItem.day == item) {
                    arrayItem.checked = true
                }
                // else {
                //     arrayItem.checked = false
                // }
            })
        }))

        console.log("this.frequencyDays ", this.frequencyDays);

    }

    if (changes.singleJobDate && changes.singleJobDate.currentValue) {
        this.singleJobDate = changes.singleJobDate.currentValue
        this.finalCourseDates = []
        this.courseDates = []
        this.singleJobDate.forEach((date) => {
            // let temp = new Date(date.date)
            // date.date = new Date(date.date)
            this.courseDates.push(date)
        })
        this.finalCourseDates = this.courseDates.sort((a, b) => (b.day) - a.day).reverse();
        console.log("this is the final course dates array", this.finalCourseDates);

    }

    if (changes.startingDate && changes.startingDate.currentValue) {
        this.startingDate = changes.startingDate.currentValue
        this.temp = moment(this.startingDate)
        this.dateForm = this.formBuilder.group({
            frequency: new FormArray([], Validators.required),
            // singleJobDates : new FormControl()
        })

        this.addCheckboxes()
    }

    // if (changes.userLogin && changes.userLogin.currentValue) {
    //   console.log("current user login details", changes.userLogin);
    //   this.user = changes.userLogin.currentValue
    //   if (this.user && this.user.isClient) {
    //     console.log("call this for client");

    //     this.checkEnable = false
    //     // this.enableCheckBoxes()
    //   } else {
    //     console.log("call this for admin", this.checkEnable);

    //     // this.checkEnable = true
    //   }
    // }
}
onCourseChange() {
    console.log('Generating dates for', this.dateForm)

    if (this.duration <= this.finalCourseDates.length) {
        this.totalDays = this.frequency;
        console.log("Hello total Days Check ==>", this.totalDays)
        this.dateChange.emit({ singleJobDates: this.finalCourseDates.slice(0, this.duration), totalDays: this.totalDays })
    }
    else {
        this.courseDates = [];

        this.finalCourseDates = [];

        console.log("in edit!!!!", this.frequency)
        if (this.frequency) {
            this.frequency.forEach((oneDay) => {
                let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                if (index > -1) {
                    console.log("index", index)
                    let dayOfWeek = this.frequencyDays[index].id
                    let event = true
                    this.generateDates(event, dayOfWeek, oneDay)
                }
            })
        }
    }
}
// generateDates() {
public generateDates(event, dayOfTheWeek, day) {
    console.log("Event", event, "DayOf The week", dayOfTheWeek, "Day", day, "total days data", this.totalDays)
    // console.log("starting selected date", this.startingDate);

    this.dayExist = false
    if (event == true) {
        if (new Date(this.startingDate).getDay() == dayOfTheWeek) {
            console.log("this.startingDate", this.startingDate)
            let obj = {
                date: this.startingDate
            }
            this.courseDates.push(obj)
            console.log("IN second if")
        }
        if (this.totalDays.length < 1) {
            console.log("CHECKING LENGTH", this.frequencyDays);
            this.totalDays.push(day)
        }
        else {
            this.totalDays.forEach((item) => {
                console.log("COMPARING EACH ITEM");
                console.log("ITEM", item, "== Day", day);
                if (item == day) {
                    console.log("ITEM", item, "== Day", day);
                    this.dayExist = true
                    console.log("After comparing DayExists", this.dayExist);
                }
            })
            if (this.dayExist == false) {
                this.totalDays.push(day)
            }
        }
        // console.log("this.totaldays", this.totalDays)

        let tempDate: Date = this.temp.toDate();
        console.log("tempDate", tempDate);
        console.log("duration===>>> ", this.duration)
        for (let i = 0; i < this.duration; i++) {
            // console.log("i", i)
            // console.log("In for loop", tempDate.getDay(), dayOfTheWeek);
            // console.log(typeof tempDate.getDay())
            // console.log(typeof dayOfTheWeek)

            if (typeof dayOfTheWeek == 'string') dayOfTheWeek = parseInt(dayOfTheWeek)
            // console.log(typeof dayOfTheWeek)

            let days = (7 - tempDate.getDay() + dayOfTheWeek)
            // console.log("In for loop days", days);
            if (days >= 8) {
                days = (-1) * (7 - days);
                console.log("In IIIFFFFF", days);
            }
            let nextDay = new Date(tempDate.setDate(tempDate.getDate() + days))
            // console.log("nextDay", nextDay);
            // console.log("temp date value========= to push=", tempDate);
            let obj = {
                date: tempDate
            }
            this.courseDates.push(obj)
            tempDate = nextDay;

        }
        // console.log("for loop ended");
    } else {
        console.log("array of Finaldates", this.finalCourseDates)
        console.log("array of course dates", this.courseDates)
        for (let i = 0; i < this.totalDays.length; i++) {
            if (this.totalDays[i] == day) {
                this.totalDays.splice(i, 1)
            }
        }
        let tempDate: Date = this.temp.toDate();
        for (let i = 0; i < this.duration; i++) {
            let days = (7 - tempDate.getDay() + dayOfTheWeek)
            if (days >= 8) {
                days = (-1) * (7 - days);
            }
            let nextDay = new Date(tempDate.setDate(tempDate.getDate() + days))
            for (let j = 0; j < this.courseDates.length; j++) {
                if (new Date(this.courseDates[j].date).getDay() == nextDay.getDay()) {
                    this.courseDates.splice(j, 1)
                }
            }
        }
    }
    console.log("final course date value", this.courseDates.sort((a, b) => b.date - a.date));
    let sortDates = this.courseDates.sort(function (a, b) {
        let c: any = new Date(a.date);
        let d: any = new Date(b.date);
        return c - d;
    });

    console.log("this is the temp sort dates array", sortDates.reverse());

    this.finalCourseDates = sortDates.reverse().slice(0, this.duration);
    // this.totalDays = []
    // this.frequencyDays.filter((data) => {
    //     if (data.checked == true) this.totalDays.push(data.day)
    // })
    console.log("DATA TO EMIT", this.finalCourseDates);
    this.dateChange.emit({ singleJobDates: this.finalCourseDates, totalDays: this.totalDays, isEdit: true })
}

public EditDates(newDate, arrayOfDays) {
    console.log('newdate assigned and all other values cleared', newDate, arrayOfDays)
    console.log("when second time date change", this.totalDays);

    if (newDate) {
        this.startingDate = newDate;
        this.temp = moment(this.startingDate)

        this.courseDates = [];

        this.finalCourseDates = [];
        if ((this.totalDays && this.totalDays.length) && this.frequency == undefined) {
            let event = true
            this.totalDays.forEach((oneDay) => {
                let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                if (index > -1) {
                    console.log("index", index)
                    let dayOfWeek = this.frequencyDays[index].id
                    let event = true
                    this.generateDates(event, dayOfWeek, oneDay)
                }
            })
        }


        console.log("in edit!!!!", this.frequency)
        if (this.frequency) {
            this.frequency.forEach((oneDay) => {
                let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                if (index > -1) {
                    console.log("index", index)
                    let dayOfWeek = this.frequencyDays[index].id
                    let event = true
                    this.generateDates(event, dayOfWeek, oneDay)
                }
            })
        }
    }

    // this.generateDates('true', )
    // console.log("array of Finaldates", this.finalCourseDates)
    // console.log("array of course dates", this.courseDates)
    // this.frequencyDays.forEach((arrayItem) => {
    //     arrayItem.checked = false
    // })
    // console.log('newdate assigned and all other values cleared')
    // this.checkEnable = false;
    // this.finalCourseDates = [];
    // this.totalDays = [];
    // this.dateChange.emit({ singleJobDates: this.finalCourseDates, totalDays: this.totalDays })
}

public clearCheckBoxes() {
    this.frequencyDays.forEach((arrayItem) => {
        arrayItem.checked = false
    })
    this.courseDates.length = 0;
    this.finalCourseDates = [];
}
onChange(value, j) {
    console.log("when change date", value);
    let date = value
    console.log(this.finalCourseDates[j])
    console.log("SINGLE DATE CHANGE EVENT", date, j)

    // this.finalCourseDates.splice(j, 1, date)
    this.finalCourseDates[j]['date'] = date
    this.finalCourseDates[j]['isEdit'] = true
    // console.log(this.finalCourseDates[j])
    console.log("Hello Here is the total days count ====>", this.totalDays)
    this.dateChange.emit({ singleJobDates: this.finalCourseDates.slice(0, this.duration), totalDays: this.totalDays, isEdit: true })
}

dateFilter = (d: Date) => {

    const arrayListDate = this.finalCourseDates.map((o) => {
        return new Date(o.date).valueOf()

    })

    return arrayListDate.indexOf(d.valueOf()) == -1;
};
}
